import { hideShowNoDataFound } from "./common";

window.$(document).ready(function() {
    /* Icon dropdown for reservation phase */
    window.$(document).on('click', '#reservation_container .bs-dropdown-to-select-group .dropdown-menu li', function (event) {
        var $target = $(event.currentTarget);
        $target.closest('.bs-dropdown-to-select-group')
            .find('[data-bind="bs-drp-sel-value"]').val($target.attr('data-value'))
            .end()
            .children('.dropdown-toggle').dropdown('toggle');
        const img = '<img src="'+$target.attr('data-value')+'" alt="">';
        $target.closest('.bs-dropdown-to-select-group')
            .find('[data-bind="bs-drp-sel-label"]').html(img);
        return false;
    });

    window.$('body').on('click', '#reservation_container .save_reservation_phase', function(e) {
        e.preventDefault();
        window.$(".error").html('');
        window.toastr.remove();

        var thisTr = window.$(this).closest('tr');
        var data = thisTr.find('input').serialize();
        var ref_this = window.$("ul.nav-tabs li a.active");
        var active_phase_category_id = ref_this.attr("id");
        var id = thisTr.attr('id');

        data = data + '&phase_category_id='+active_phase_category_id;

        var queryString = '';
        if(id !== '' && id !== undefined){
            queryString = '/' + id;
        }

        window.axios({
            method: queryString == ''? "post": "put",
            url: window.$("#reservation_phase_store_route").val() + queryString,
            data: data
        })
            .then(function(response) {
                let newTrDom;
                let errorNameId;
                let tableIndex;
                if(document.getElementById('cat-1').classList.contains('active')){
                    newTrDom = $("tr[data-row-id=new-tr-1]");
                    errorNameId = 'new-tr-1';
                    tableIndex = 0;
                }else if(document.getElementById('cat-2').classList.contains('active')){
                    newTrDom = $("tr[data-row-id=new-tr-2]");
                    errorNameId = 'new-tr-2';
                    tableIndex = 1;
                }
                //displayReservationPhaseTabContents();
                if(response.data.data){
                    let phaseData       =   response.data.data;
                    let phase_id        =   phaseData.id;
                    let phase_name      =   phaseData.name;
                    let phase_status    =   phaseData.status;
                    let phase_icon      =   phaseData.icon;
                    if($("#"+phase_id).length == 0){
                        let newtrhtml = newTrDom.html();
                        let newIconDom = newTrDom.find(".icon_td").html();
                        let newNameDom = newTrDom.find(".name").html();
                        let newStatusDom = newTrDom.find(".status").html();
                        let newSaveCancelDom = newTrDom.find('td:last-child').html();
                        let trDOM = '<tr data-row-id="tr-'+phase_id+'" id="'+phase_id+'" class="reservation_preview">';
                        let icontdDom = '<td class="icon-td">';
                            icontdDom += '<div class="preview"><img src="'+phase_icon+'" width="30"></div>';
                            icontdDom += '<div class="td_edit">'+newIconDom+'</div>';
                            icontdDom += '</td>';
                        let nametdDom = '<td class="name">';
                            nametdDom += '<div class="preview">'+phase_name+'</div>';
                            nametdDom += '<div class="td_edit">'+newNameDom+'</div>';
                            nametdDom += '</td>';
                        let statustdDom = '<td class="status">';
                            statustdDom += newStatusDom;
                            statustdDom += '</td>';
                        let lasttdDom = '<td>';
                            lasttdDom += '<div class="preview"><a href="javascript:void(0)" title="Edit" class="action editResPhase pr-2"><i class="fa fa-pen edit"></i></a></div>';
                            lasttdDom += '<div class="td_edit">'+newSaveCancelDom+'</div>';
                            lasttdDom += '</td>';
                        trDOM += icontdDom;
                        trDOM += nametdDom;
                        trDOM += statustdDom;
                        trDOM += lasttdDom;
                        trDOM += '</tr>';

                        newTrDom.addClass('d-none');
                        $(".reservation_phase_tab > table.dataTable:eq("+tableIndex+") > tbody tr:first").after(trDOM);
                        let nameEditDom      =   $("#"+phase_id).find('td.name .td_edit');
                        let firststatusDom        =   $("#"+phase_id).find('td.status').find('input[type=checkbox]');
                        if(phase_status == 'active'){
                            firststatusDom.prop('checked',true);
                        }else{
                            firststatusDom.prop('checked',false);
                        }
                        nameEditDom.find('input[name=name]').val(phase_name);
                        newTrDom.find(".name").find('input[name=name]').val('');
                        newTrDom.find(".icon_td").find('input[name=icon]').val('/images/icons/1.png')
                        newTrDom.find(".icon_td").find('div > button > span > img').attr('src','/images/icons/1.png')
                        newTrDom.find(".status").find('input[name=status]').prop('checked',true)
                        $("#"+errorNameId+"-name-error").attr('id','tr-'+phase_id+'-name-error')
                    }else{
                        let iconpreviewDom   =   $("#"+phase_id).find('td.icon_td .preview');
                        let iconeditDom      =   $("#"+phase_id).find('td.icon_td .td_edit');

                        let namepreviewDom   =   $("#"+phase_id).find('td.name .preview');
                        let nameeditDom      =   $("#"+phase_id).find('td.name .td_edit');

                        let statusDom        =   $("#"+phase_id).find('td.status').find('input[type=checkbox]');

                        let editiconDom      =   $("#"+phase_id+" td:last-child").find(".preview");
                        let saveCancelDom    =   $("#"+phase_id+" td:last-child").find(".td_edit");

                        // SET ICON DOM VALUES
                        iconpreviewDom.find('img').attr('src',phase_icon);
                        iconeditDom.find('input[name=icon]').val(phase_icon);

                        // SET NAME DOM VALUES
                        namepreviewDom.html(phase_name);
                        nameeditDom.find('input[name=name]').val(phase_name);

                        // SET STATUS DOM VALUES
                        if(phase_status == 'active'){
                            statusDom.prop('checked',true);
                        }else{
                            statusDom.prop('checked',false);
                        }
                    }
                    $("tr[id='"+phase_id+"']").removeClass('reservation_edit').addClass('reservation_preview');
                }
                
                window.$("#reservation_container .add_new_btn").removeAttr("disabled");
                window.toastr.success(response.data.message, response.statusText);
            })
            .catch(function(error) {
                if (error.response.status == 400) {
                    window.$.each(error.response.data, function(key, value) {
                        var fieldId = thisTr.attr('data-row-id');
                        window.$('#' + fieldId + '-' + key + '-error').text(value[0]);
                    });
                } else if (error.response.status == 500) {
                    window.toastr.error(error.response.data.message, error.response.statusText);
                }
            });
        return false;
    });


    displayReservationPhaseTabContents();
    /*
     * Edit reservation phase
     */
    window.$('body').on('click', '#reservation_container .editResPhase', function(e) {
        window.$(this).closest('tr').removeClass('reservation_preview').addClass('reservation_edit');
    });

    /*
     *
     * Add new reservation phase
     *
     */
    window.$('body').on('click', '#reservation_container #createResPhase', function(e) {
        var ref_this = window.$("ul.nav-tabs li a.active");
        var active_phase_category_id = ref_this.attr("id");

        window.$('*[data-row-id="new-tr-'+active_phase_category_id+'"]').closest('table').find('tbody tr:first').removeClass('d-none');
        window.$(this).attr("disabled", "disabled");
        if(window.$('*[data-row-id="new-tr-'+active_phase_category_id+'"]').closest('table').find('tr').length > 1){
            window.$('*[data-row-id="new-tr-'+active_phase_category_id+'"]').closest('table').find('#no_data_avaiable').hide();
        }

    });

    window.$('body').on('click', '.reservation_phase_tab .status_checkbox', function(e) {
        window.$(".error").html('');
        window.toastr.remove();

        var id = window.$(this).closest('tr').prop('id');
        if(id) {
            var status = '';
            let t = window.$(this);
            if (window.$(this).is(':checked')) {
                status = 'active';
            }
            else {
                status = 'inactive';
            }

            window.axios({
                method: "put",
                url: window.$("#reservation_phase_store_route").val() + '/' + id,
                data: {
                    'id': id,
                    'status': status,
                    'update_status': true
                }
            })
                .then(function(response) {
                    window.toastr.success(response.data.message, response.statusText);
                })
                .catch(function(error) {
                    if (error.response.status == 500) {
                        window.toastr.error(error.response.data.message, error.response.statusText);
                    }else if (error.response.status == 401) {
                            window.toastr.error(error.response.data.message, error.response.statusText);
                            if(status == 'active'){
                                window.$(t).prop('checked',false);
                            }else if(status == 'inactive'){
                                window.$(t).prop('checked',true);
                            }
                        }

                });
        }else{
            if (window.$(this).is(':checked')) {
                window.$(this).prop('checked',true)
            }
            else {
                window.$(this).prop('checked',false)
            }
        }
    });


    /*
     * Remove new reservation phase tr
     */
    window.$('body').on('click', '.res_phase_content .remove', function(e) {
        // if cancel current editing row
        if(window.$(this).hasClass('cancel_edit')) {
            window.$(this).closest('tr').removeClass('reservation_edit').addClass('reservation_preview');
            return true;
        }
        var ref_this = window.$("ul.nav-tabs li a.active");
        var active_phase_category_id = ref_this.attr("id");

        window.$('*[data-row-id="new-tr-'+active_phase_category_id+'"]').closest('table').find('tbody tr:first').addClass('d-none');
        window.$("#reservation_container .add_new_btn").removeAttr("disabled");
        if(window.$('*[data-row-id="new-tr-'+active_phase_category_id+'"]').closest('table').find('tr').length > 3){
            window.$('*[data-row-id="new-tr-'+active_phase_category_id+'"]').closest('table').find('#no_data_avaiable').hide();
        } else {
            window.$('*[data-row-id="new-tr-'+active_phase_category_id+'"]').closest('table').find('#no_data_avaiable').show();
        }
    });

 });


function displayReservationPhaseTabContents() {
    /*
     * Get reservation phase tab's contents
     */
    var ref_this = window.$("ul.nav-tabs li a.active");
    var active_phase_category_id = ref_this.attr("id");

    var ajaxUrl = window.$('#index_route').val();
    if(active_phase_category_id) {
        window.axios({
            method: "get",
            url: ajaxUrl,
            data: {}
        })
            .then(function(response) {
                //window.toastr.success(response.data.message, response.statusText);
                window.$('#reservation_phase_tabs').html(response.data);
                if(active_phase_category_id){
                    window.$(".res_phase_content .tab-pane").removeClass('active');
                    window.$("#cat-"+active_phase_category_id).addClass('active');
                }
            })
            .catch(function(error) {
                if (error.response.status == 500) {
                    window.toastr.error(error.response.data.message, error.response.statusText);
                }
            });
    }
}
window.addEventListener('DOMContentLoaded',function(){
if(window.location.pathname == '/core/reservationPhases'){
        window.onbeforeunload = function (e) {
            if($(".reservation_edit").length >=1)
            {
                e = e || window.event;
                // For IE and Firefox
                if (e) {
                    e.returnValue = null;
                }
                // For Safari
                return null;
            }else{
    
            }
        } 
}else{
    window.onbeforeunload = null;
}
});
